var map = {
	"./AdvancedOptions.vue": 3641,
	"./Agenda.vue": 4201,
	"./Auth/ConfirmPassword.vue": 6836,
	"./Auth/ForgotPassword.vue": 7736,
	"./Auth/Login.vue": 8400,
	"./Auth/Register.vue": 7028,
	"./Auth/ResetPassword.vue": 7046,
	"./Auth/VerifyEmail.vue": 7576,
	"./Ayuda.vue": 9155,
	"./CategoryCard.vue": 1842,
	"./ClaimList.vue": 9394,
	"./CollaboratorCard.vue": 4924,
	"./CollaboratorList.vue": 1339,
	"./CollaboratorRegistroAsistencia.vue": 7955,
	"./ConfigAsistencia.vue": 3705,
	"./ConfigCatalogo.vue": 2326,
	"./ConfigClassRoom.vue": 631,
	"./ConfigColegio.vue": 6971,
	"./ConfigCompany.vue": 9858,
	"./ConfigComplaintBook.vue": 3800,
	"./ConfigCourse.vue": 5230,
	"./ConfigCourseArea.vue": 1445,
	"./ConfigDistrito.vue": 383,
	"./ConfigEcommerce.vue": 6538,
	"./ConfigHelp.vue": 4210,
	"./ConfigLevel.vue": 63,
	"./ConfigParentesco.vue": 356,
	"./ConfigReligion.vue": 9749,
	"./ConfigTypeDoc.vue": 4157,
	"./Configuration.vue": 4653,
	"./Curricula.vue": 2038,
	"./Dashboard.vue": 9271,
	"./DiarioList.vue": 9512,
	"./DocumentForLevel.vue": 938,
	"./EcommerceBrands.vue": 9895,
	"./EcommerceCategory.vue": 9665,
	"./EcommerceCheckout.vue": 4148,
	"./EcommerceClaimCard.vue": 195,
	"./EcommerceCompanyInfo.vue": 2723,
	"./EcommerceComplaintsBook.vue": 6811,
	"./EcommerceContactInfo.vue": 3495,
	"./EcommerceDeliveryTypes.vue": 3406,
	"./EcommerceInfoAddress.vue": 4146,
	"./EcommerceLegalBases.vue": 8953,
	"./EcommerceOrder.vue": 8072,
	"./EcommercePaymentMethods.vue": 2965,
	"./EcommerceProductCard.vue": 8665,
	"./EcommerceServices.vue": 5866,
	"./EcommerceShoppingCart.vue": 351,
	"./EcommerceTermsConditions.vue": 880,
	"./EcommerceTest.vue": 7626,
	"./EcommerceWarrantyPolicies.vue": 1145,
	"./FileCard.vue": 7096,
	"./FileList.vue": 3065,
	"./FinancieraCard.vue": 9990,
	"./Freeday.vue": 5691,
	"./FreedayCard.vue": 2592,
	"./ImportExcel.vue": 3525,
	"./Offline.vue": 1785,
	"./Perfil.vue": 139,
	"./Product.vue": 6367,
	"./ProductCard.vue": 6411,
	"./Report.vue": 7201,
	"./ReportAsistencia.vue": 2813,
	"./ReportCalification.vue": 9006,
	"./ReportCalificationMerito.vue": 7406,
	"./ReportRegistroAsistencia.vue": 3940,
	"./ReportStudent.vue": 4756,
	"./Student.vue": 2414,
	"./StudentCard.vue": 4488,
	"./StudentCourseCard.vue": 3932,
	"./StudentCourses.vue": 9263,
	"./StudentForm.vue": 3423,
	"./UserCard.vue": 7777,
	"./UserList.vue": 9992,
	"./Welcome.vue": 5016,
	"./bak/ComplaintsBook.vue": 60,
	"./bak/ConfigCatalogo.vue": 7826,
	"./bak/TableAdvanced.vue": 6385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6634;